function RenovationBlock(props) {
  let { children } = props;
  return <div className="renovation-block">{children}</div>;
}
export default RenovationBlock;
